<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="viewModel.title"
    aria-level="2"
    icon="check_circle"
    icon-tone="success"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <div class="emission-register-success-modal">
      <p class="emission-register-success-modal__description">{{ viewModel.description }}</p>

      <div class="emission-register-success-modal__details">
        <p class="emission-register-success-modal__details-title">Detalhes da Emissão</p>
        <div class="emission-register-success-modal__details-list">
          <div class="emission-register-success-modal__detail-row">
            <span class="emission-register-success-modal__detail-label">Nome do projeto</span>
            <span class="emission-register-success-modal__detail-value">{{ viewModel.projectName }}</span>
          </div>
          <div class="emission-register-success-modal__detail-row">
            <span class="emission-register-success-modal__detail-label">Data do envio</span>
            <span class="emission-register-success-modal__detail-value">{{ viewModel.sentDateLabel }}</span>
          </div>
          <div class="emission-register-success-modal__detail-row">
            <span class="emission-register-success-modal__detail-label">Status</span>
            <span class="emission-register-success-modal__status-badge">
              <b3-icon name="sync" size="md" class="emission-register-success-modal__status-icon"></b3-icon>
              <span class="emission-register-success-modal__status-text">{{ viewModel.statusLabel }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="emission-register-success-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onNewEmission()">
        <b3-icon name="add" size="md"></b3-icon>
        Nova Emissão
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConsultEmission()">
        <b3-icon name="search" size="md" tone="on-brand"></b3-icon>
        Consultar Emissão
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
